import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeopleProfileEditDetailsModalComponent } from './people-profile-edit-details-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GooglePlacesLocationModule } from 'src/app/lib/google-places-location/google-places-location/google-places-location.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PlacesService } from 'src/app/services/places/places.service';
import { InputsModule, DropdownModule, ButtonModule } from '@xref/xref-lib';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import { i18nPipeModule } from 'src/app/pipes/i18n-convertor-pipe/i18n-convertor.module';
import { PhoneInputModule } from "../../../lib/phone-input/phone-input.module";

@NgModule({
  declarations: [PeopleProfileEditDetailsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    GooglePlacesLocationModule,
    NgbModule,
    ReactiveFormsModule,
    InputsModule,
    DropdownModule,
    ButtonModule,
    i18nPipeModule,
    BsDatepickerModule.forRoot(),
    PhoneInputModule
  ],
  providers:[PlacesService],
  exports: [PeopleProfileEditDetailsModalComponent]
})
export class PeopleProfileEditDetailsModalModule { }
